export const feedbackEs = {
  open: 'Enviar comentarios',
  title: 'Enviar comentarios',
  description:
    'Informe de un problema, una pregunta o una sugerencia sin salir de la página actual.',
  submit: 'Enviar comentario',
  submitting: 'Enviando …',
  types: {
    BUG: 'Algo no funciona',
    FEATURE_REQUEST: 'Solicitud de función',
    IMPROVEMENT: 'Propuesta de mejora',
    USABILITY: 'Problema de usabilidad',
    DATA_ISSUE: 'Los datos parecen incorrectos o incompletos',
    PERFORMANCE: 'La página es lenta o no responde',
    QUESTION: 'Pregunta sobre una función',
    OTHER: 'Otro',
  },
  urgencies: {
    LOW: 'Baja',
    NORMAL: 'Normal',
    HIGH: 'Alta',
    BLOCKING: 'No puedo continuar trabajando',
  },
  reproducibility: {
    ALWAYS: 'Siempre',
    SOMETIMES: 'A veces',
    ONCE: 'Una vez',
    NOT_TRIED: 'Aún no probado',
  },
  statuses: {
    SUBMITTED: 'Recibido',
    TRIAGED: 'Evaluado',
    IN_PROGRESS: 'En curso',
    RESOLVED: 'Resuelto',
    CLOSED: 'Cerrado',
  },
  priorities: { LOW: 'Baja', MEDIUM: 'Media', HIGH: 'Alta', CRITICAL: 'Crítica' },
  fields: {
    type: 'Tipo de comentario',
    urgency: 'Urgencia percibida',
    title: 'Título breve',
    description: 'Descripción detallada',
    noSecrets: 'No introduzca contraseñas, tokens, datos de pago ni contenido confidencial.',
    attemptedAction: '¿Qué intentó hacer?',
    actualResult: '¿Qué ocurrió realmente?',
    expectedResult: '¿Qué esperaba que ocurriera?',
    reproducibility: '¿Se puede reproducir el problema?',
    reproductionSteps: 'Pasos opcionales para reproducirlo',
    affectedFeature: 'Función afectada (opcional)',
    wantsFollowUp: 'Deseo que se pongan en contacto',
    problematicFields: 'Campos problemáticos',
    choose: 'Seleccione',
  },
  bug: { title: 'Detalles del error' },
  screenshot: {
    title: 'Captura de pantalla (opcional)',
    hint: 'Revise y oculte las zonas confidenciales antes de enviar.',
    choose: 'Elegir imagen',
    remove: 'Eliminar',
    invalid: 'No se pudo leer la imagen.',
    maskArea: 'Área para ocultar la captura',
    maskInstructions: 'Arrastre sobre zonas confidenciales para ocultarlas de forma permanente.',
    resetMasks: 'Restablecer máscaras',
  },
  diagnostics: {
    includeExtended: 'Adjuntar diagnóstico ampliado',
    title: 'Mostrar datos de diagnóstico',
    transparency:
      'Usted decide qué secciones técnicas se envían. El servidor añade el contexto de sesión verificado.',
    exclusions:
      'Nunca se recopilan entradas, búsquedas, contraseñas, tokens, mensajes, archivos, portapapeles, audio, cámara, ubicación ni movimientos del ratón.',
    sections: {
      APPLICATION: 'Aplicación y compilación',
      PAGE: 'Página actual',
      BROWSER: 'Navegador y dispositivo',
      BREADCRUMBS: 'Acciones semánticas recientes',
    },
  },
  discard: {
    title: '¿Descartar borrador?',
    description: 'Se perderá la información no enviada.',
    continue: 'Seguir editando',
    confirm: 'Descartar borrador',
  },
  success: {
    title: 'Comentario enviado',
    description: 'Guarde esta referencia para consultas.',
    toast: 'Se envió el comentario {{reference}}.',
  },
  admin: {
    requested: 'Sí',
    nav: 'Centro de comentarios',
    title: 'Centro de comentarios',
    subtitle: 'Gestione comentarios enviados conscientemente con diagnóstico depurado.',
    loadError: 'No se pudieron cargar los comentarios.',
    empty: 'No hay comentarios para los filtros seleccionados.',
    detailTitle: 'Detalles del comentario',
    screenshotAlt: 'Captura ocultada para {{reference}}',
    triage: 'Evaluación técnica',
    unrated: 'Sin evaluar',
    saved: 'Comentario actualizado.',
    invalidErrorIds: 'Las referencias de error no son válidas.',
    linkedErrors: 'Errores del sistema vinculados',
    kpi: { open: 'Informes abiertos', untriaged: 'Sin evaluar', last24h: 'Últimas 24 horas' },
    columns: {
      reference: 'Referencia',
      createdAt: 'Fecha',
      type: 'Tipo',
      title: 'Título',
      user: 'Usuario',
      status: 'Estado',
    },
    fields: {
      status: 'Estado de tramitación',
      priority: 'Prioridad técnica',
      errorIds: 'IDs de error (separados por comas)',
      notes: 'Notas internas',
    },
    filters: {
      search: 'Referencia, título o descripción',
      type: 'Filtrar tipo',
      status: 'Filtrar estado',
      priority: 'Filtrar prioridad',
      all: 'Todos',
    },
    prompt: {
      title: 'Prompt depurado de soporte/Copilot',
      hint: 'El texto y los diagnósticos se comprueban de nuevo antes de copiarlos.',
      copy: 'Copiar prompt depurado',
      copied: 'Prompt depurado copiado.',
    },
  },
} as const;
